import React from 'react';
import { motion } from 'framer-motion';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { useScreenInit } from '../useScreenInit';
import { Phone, Mail, Clock, MapPin, Instagram, Facebook } from 'lucide-react';
const FAQS = [{
  question: 'How far in advance should I book?',
  answer: 'We recommend booking at least 3-6 months in advance for large events and weddings. However, we do accommodate last-minute requests based on inventory availability.'
}, {
  question: 'Do you provide delivery and setup?',
  answer: 'Yes, we offer full-service delivery, professional setup, and post-event breakdown for all our rental items to ensure a seamless experience.'
}, {
  question: 'Can I visit your showroom?',
  answer: 'Absolutely! We love meeting our clients. Showroom visits are by appointment only to ensure you have our undivided attention.'
}];
export function Contact() {
  useScreenInit();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} className="min-h-screen bg-white font-sans selection:bg-[#b22222] selection:text-white" data-id="element-249">
      <TopBar data-id="element-250" />
      <Navbar data-id="element-251" />

      <main data-id="element-252">
        {/* Page Hero with Background Image */}
        <section className="relative h-[40vh] flex items-center justify-center bg-black overflow-hidden" data-id="element-253">
          <div className="absolute inset-0 bg-cover bg-center opacity-50" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop")'
        }} data-id="element-254" />
          <div className="relative text-center text-white z-10" data-id="element-255">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-[10px] uppercase tracking-[0.4em] font-bold mb-4 block" data-id="element-256">
              Get In Touch
            </motion.span>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="font-serif text-5xl md:text-7xl italic" data-id="element-257">
              Contact Us
            </motion.h1>
          </div>
        </section>

        {/* Contact Grid */}
        <section className="py-24" data-id="element-258">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-259">
            <div className="max-w-[1440px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-20" data-id="element-260">
              {/* Info Column */}
              <div className="lg:col-span-5 space-y-12" data-id="element-261">
                <div className="space-y-6" data-id="element-262">
                  <h2 className="font-serif text-3xl text-gray-900" data-id="element-263">
                    Let's start planning.
                  </h2>
                  <p className="text-gray-500 leading-relaxed" data-id="element-264">
                    Have a question or ready to book? Fill out the form or reach
                    out directly. We look forward to bringing elegance to your
                    next celebration.
                  </p>
                </div>

                <div className="space-y-8" data-id="element-265">
                  <div className="flex items-start gap-6" data-id="element-266">
                    <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full text-[#b22222]" data-id="element-267">
                      <Phone size={20} data-id="element-268" />
                    </div>
                    <div data-id="element-269">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-gray-400 mb-1" data-id="element-270">
                        Call Us
                      </p>
                      <p className="text-lg font-medium text-gray-900" data-id="element-271">
                        (555) 123-4567
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6" data-id="element-272">
                    <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full text-[#b22222]" data-id="element-273">
                      <Mail size={20} data-id="element-274" />
                    </div>
                    <div data-id="element-275">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-gray-400 mb-1" data-id="element-276">
                        Email Us
                      </p>
                      <p className="text-lg font-medium text-gray-900" data-id="element-277">
                        hello@chynedesigns.com
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6" data-id="element-278">
                    <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full text-[#b22222]" data-id="element-279">
                      <Clock size={20} data-id="element-280" />
                    </div>
                    <div data-id="element-281">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-gray-400 mb-1" data-id="element-282">
                        Office Hours
                      </p>
                      <p className="text-lg font-medium text-gray-900" data-id="element-283">
                        Mon - Fri: 9am - 6pm
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6" data-id="element-284">
                    <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full text-[#b22222]" data-id="element-285">
                      <MapPin size={20} data-id="element-286" />
                    </div>
                    <div data-id="element-287">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-gray-400 mb-1" data-id="element-288">
                        Service Area
                      </p>
                      <p className="text-lg font-medium text-gray-900" data-id="element-289">
                        Serving the Tri-State Area & Beyond
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-8 border-t border-gray-100 flex gap-6" data-id="element-290">
                  <a href="#" className="text-gray-400 hover:text-[#b22222] transition-colors" data-id="element-291">
                    <Instagram size={24} data-id="element-292" />
                  </a>
                  <a href="#" className="text-gray-400 hover:text-[#b22222] transition-colors" data-id="element-293">
                    <Facebook size={24} data-id="element-294" />
                  </a>
                </div>
              </div>

              {/* Form Column */}
              <div className="lg:col-span-7" data-id="element-295">
                <form className="bg-white border border-gray-100 p-10 shadow-2xl space-y-8" data-id="element-296">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-297">
                    <div className="space-y-2" data-id="element-298">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-gray-400" data-id="element-299">
                        Full Name
                      </label>
                      <input type="text" className="w-full border-b border-gray-200 py-3 focus:border-[#b22222] outline-none transition-colors" placeholder="Jane Doe" data-id="element-300" />
                    </div>
                    <div className="space-y-2" data-id="element-301">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-gray-400" data-id="element-302">
                        Email Address
                      </label>
                      <input type="email" className="w-full border-b border-gray-200 py-3 focus:border-[#b22222] outline-none transition-colors" placeholder="jane@example.com" data-id="element-303" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-304">
                    <div className="space-y-2" data-id="element-305">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-gray-400" data-id="element-306">
                        Event Date
                      </label>
                      <input type="date" className="w-full border-b border-gray-200 py-3 focus:border-[#b22222] outline-none transition-colors" data-id="element-307" />
                    </div>
                    <div className="space-y-2" data-id="element-308">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-gray-400" data-id="element-309">
                        Event Type
                      </label>
                      <select className="w-full border-b border-gray-200 py-3 focus:border-[#b22222] outline-none transition-colors bg-transparent" data-id="element-310">
                        <option data-id="element-311">Wedding</option>
                        <option data-id="element-312">Corporate</option>
                        <option data-id="element-313">Private Party</option>
                        <option data-id="element-314">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-315">
                    <label className="text-[10px] uppercase tracking-widest font-bold text-gray-400" data-id="element-316">
                      Message
                    </label>
                    <textarea rows={4} className="w-full border-b border-gray-200 py-3 focus:border-[#b22222] outline-none transition-colors resize-none" placeholder="Tell us about your vision..." data-id="element-317" />
                  </div>

                  <button className="w-full bg-black text-white py-5 text-xs font-bold uppercase tracking-widest hover:bg-[#b22222] transition-all duration-300" data-id="element-318">
                    Send Inquiry
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-24 bg-gray-50" data-id="element-319">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-320">
            <div className="max-w-[1440px] mx-auto px-6" data-id="element-321">
              <div className="text-center mb-16" data-id="element-322">
                <h2 className="font-serif text-4xl text-gray-900 mb-4" data-id="element-323">
                  Common Questions
                </h2>
                <div className="w-20 h-[1px] bg-[#b22222] mx-auto" data-id="element-324" />
              </div>

              <div className="max-w-3xl mx-auto space-y-10" data-id="element-325">
                {FAQS.map((faq, index) => <div key={index} className="space-y-3" data-id="element-326">
                    <h3 className="font-serif text-xl text-gray-900" data-id="element-327">
                      {faq.question}
                    </h3>
                    <p className="text-gray-500 leading-relaxed" data-id="element-328">
                      {faq.answer}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-white py-12 border-t border-gray-100" data-id="element-329">
        <div className="mx-4 md:mx-[4.1rem]" data-id="element-330">
          <div className="max-w-[1440px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-331">
            <div className="flex flex-col items-center md:items-start leading-none" data-id="element-332">
              <span className="font-script text-3xl text-black" data-id="element-333">
                Chyne Designs
              </span>
              <span className="text-[8px] uppercase tracking-[0.2em] font-bold text-gray-400 mt-1" data-id="element-334">
                Elegant Events & Rentals LLC
              </span>
            </div>
            <div className="flex gap-8 text-[11px] font-bold uppercase tracking-widest text-gray-500" data-id="element-335">
              <a href="#" className="hover:text-black transition-colors" data-id="element-336">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-black transition-colors" data-id="element-337">
                Terms of Service
              </a>
              <a href="#" className="hover:text-black transition-colors" data-id="element-338">
                Contact
              </a>
            </div>
            <p className="text-[11px] text-gray-400" data-id="element-339">
              © 2026 Chyne Designs Elegant Events & Rentals LLC. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </motion.div>;
}